"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactJss = _interopRequireDefault(require("react-jss"));

var _clsx = _interopRequireDefault(require("clsx"));

var _PeriodChange = _interopRequireDefault(require("./PeriodChange.style"));

var _Icon = _interopRequireDefault(require("../../Icon"));

var _Label = _interopRequireDefault(require("../../Label"));

var _dateUtils = _interopRequireDefault(require("../../utils/dateUtils"));

var _dec, _class;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

let PeriodChange = (_dec = (0, _reactJss.default)(_PeriodChange.default), _dec(_class = class PeriodChange extends _react.PureComponent {
  // Проверка можно ли листать месяц/год вперед
  canNext(type) {
    const {
      viewDate,
      maxValue
    } = this.props;
    if (!maxValue) return true;

    if (type === 'month') {
      return maxValue.getFullYear() > viewDate.getFullYear() || maxValue.getFullYear() >= viewDate.getFullYear() && maxValue.getMonth() > viewDate.getMonth();
    }

    return maxValue.getFullYear() > viewDate.getFullYear();
  } // Проверка можно ли листать месяц/год назад


  canPrev(type) {
    const {
      viewDate,
      minValue
    } = this.props;
    if (!minValue) return true;

    if (type === 'month') {
      return minValue.getFullYear() < viewDate.getFullYear() || minValue.getFullYear() === viewDate.getFullYear() && minValue.getMonth() <= viewDate.getMonth() - 1;
    }

    return minValue.getFullYear() < viewDate.getFullYear();
  } // Переключение месяца


  handleChangeMonth(direction) {
    const {
      viewDate,
      onChange
    } = this.props;
    const changedDate = new Date(viewDate);

    if (direction === 'prev' && this.canPrev('month')) {
      changedDate.setMonth(viewDate.getMonth() - 1, 1);
    } else if (direction === 'next' && this.canNext('month')) {
      changedDate.setMonth(viewDate.getMonth() + 1, 1);
    }

    onChange(changedDate);
  } // Переключение года


  handleChangeYear(direction) {
    const {
      maxValue,
      minValue,
      viewDate,
      onChange
    } = this.props;
    const changedDate = new Date(viewDate);

    if (direction === 'prev' && this.canPrev('year')) {
      changedDate.setFullYear(viewDate.getFullYear() - 1);
    } else if (direction === 'next' && this.canNext('year')) {
      changedDate.setFullYear(viewDate.getFullYear() + 1);
    } // Корректировка максимального и минимального месяца


    if (!this.canNext('month') && changedDate.getMonth() !== maxValue.getMonth()) {
      changedDate.setMonth(maxValue.getMonth());
    } else if (!this.canPrev('month') && changedDate.getMonth() !== minValue.getMonth()) {
      changedDate.setMonth(minValue.getMonth());
    }

    onChange(changedDate);
  }

  render() {
    const {
      classes,
      className,
      size,
      viewDate
    } = this.props;
    const month = viewDate.getMonth();
    const year = viewDate.getFullYear();
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _clsx.default)(className, classes[size], classes.period)
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      className: (0, _clsx.default)(classes.periodItem, classes.periodIcon, classes.prevYearIcon),
      type: "arrows",
      onClick: () => this.handleChangeYear('prev'),
      visibility: this.canPrev('year') ? 'visible' : 'disabled',
      size: "small",
      color: "currentColor"
    }), /*#__PURE__*/_react.default.createElement(_Icon.default, {
      className: (0, _clsx.default)(classes.periodItem, classes.periodIcon, classes.prevMonthIcon),
      type: "arrow",
      onClick: () => this.handleChangeMonth('prev'),
      visibility: this.canPrev('month') ? 'visible' : 'disabled',
      size: "small",
      color: "currentColor"
    }), /*#__PURE__*/_react.default.createElement(_Label.default, {
      className: (0, _clsx.default)(classes.periodItem, classes.monthYear),
      value: `${_dateUtils.default.getMonth([month])}, ${year}`,
      fontSize: size,
      fontWeight: "semibold"
    }), /*#__PURE__*/_react.default.createElement(_Icon.default, {
      className: (0, _clsx.default)(classes.periodItem, classes.periodIcon, classes.nextMonthIcon),
      type: "arrow",
      onClick: () => this.handleChangeMonth('next'),
      visibility: this.canNext('month') ? 'visible' : 'disabled',
      size: "small",
      color: "currentColor"
    }), /*#__PURE__*/_react.default.createElement(_Icon.default, {
      className: (0, _clsx.default)(classes.periodItem, classes.periodIcon, classes.nextYearIcon),
      type: "arrows",
      onClick: () => this.handleChangeYear('next'),
      visibility: this.canNext('year') ? 'visible' : 'disabled',
      size: "small",
      color: "currentColor"
    }));
  }

}) || _class);
var _default = PeriodChange;
exports.default = _default;